import JsEvent from '@rotomeca/event';
import BnumElement from 'components/bnum-element';
import { ClickCallback } from 'core/utils/types';

/**
 * Initialise le gestionnaire de clic pour un item de carte.
 * @param event L'événement JsEvent à déclencher.
 * @param instance L'instance de BnumElement sur laquelle écouter le clic.
 */
export function onItemClickedInitializer(
	event: JsEvent<ClickCallback>,
	instance: BnumElement,
) {
	instance.addEventListener('click', e => {
		if (event.haveEvents()) event.call(e);
	});
}
